import jsCookie from "js-cookie"

export function setCookie(params: any) {
  jsCookie.set('GZCEPT_WEBAPP_LOGIN_LOCAL_KEY', JSON.stringify(params), { expires: 7 })
}

export function getCookie() {
  const userInfo = jsCookie.get('GZCEPT_WEBAPP_LOGIN_LOCAL_KEY')
  return userInfo
}

export function setCookieCourse(params: any) {
  jsCookie.set('GZCEPT_WEBAPP_COURSE_LOCAL_KEY', JSON.stringify(params), { expires: 7 })
}

export function getCookieCourse() {
  const info = jsCookie.get('GZCEPT_WEBAPP_COURSE_LOCAL_KEY')
  return info
}

export function removeCookie() {
  jsCookie.remove('GZCEPT_WEBAPP_LOGIN_LOCAL_KEY')
  jsCookie.remove('GZCEPT_WEBAPP_COURSE_LOCAL_KEY')
}